import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import { multiSelectPropTypes } from "../selectPropTypes";
import { Select } from "components";

const MultiSelectUnstyled = ({
  allSelectedLabel,
  renderValue,
  value,
  onChange,
  placeholder,
  className,
  ...props
}) => {
  const { t } = useTranslation();

  const handleRenderValue = () => {
    if (typeof renderValue === "function") {
      return renderValue(value);
    }
    return t("Components.MultiSelect.DefaultRenderValue", {
      count: value?.length || 0,
    });
  };

  const handleChange = (e) => {
    onChange?.(e.target?.value);
  };

  return (
    <Select
      {...props}
      value={value}
      onChange={handleChange}
      isMultiple
      placeholder={!value?.length ? placeholder : undefined}
      renderValue={handleRenderValue}
      classNames={{ select: className }}
      itemRenderer={({ option }) => {
        const isChecked = value.includes(option.value);
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="checkbox"
              checked={isChecked}
              style={{ cursor: "pointer" }}
              onChange={() => {}}
            />
            <span>{option.label}</span>
          </div>
        );
      }}
    />
  );
};

const MultiSelect = styled(MultiSelectUnstyled)({});

export default MultiSelect;

MultiSelect.propTypes = multiSelectPropTypes;
